// Developed by Softvative.com
import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiCalendar, FiClock } = FiIcons;

const UpcomingChanges = () => {
    const changes = [
        {
            id: 'CHG-452',
            title: 'Database server patching',
            status: 'Approved',
            risk: 'Medium',
            scheduledDate: 'Tomorrow, 01:00 AM'
        },
        {
            id: 'CHG-451',
            title: 'Network firewall upgrade',
            status: 'Pending Approval',
            risk: 'High',
            scheduledDate: 'Jun 15, 02:00 AM'
        },
        {
            id: 'CHG-450',
            title: 'Email server maintenance',
            status: 'Scheduled',
            risk: 'Low',
            scheduledDate: 'Jun 18, 11:00 PM'
        }
    ];

    const getRiskClass = (risk) => {
        const classes = {
            'High': 'text-red-600 dark:text-red-400 bg-red-100 dark:bg-red-900/30',
            'Medium': 'text-yellow-600 dark:text-yellow-400 bg-yellow-100 dark:bg-yellow-900/30',
            'Low': 'text-green-600 dark:text-green-400 bg-green-100 dark:bg-green-900/30'
        };
        return classes[risk] || classes.Medium;
    };

    const getStatusClass = (status) => {
        const classes = {
            'Approved': 'text-green-600 dark:text-green-400 bg-green-100 dark:bg-green-900/30',
            'Pending Approval': 'text-orange-600 dark:text-orange-400 bg-orange-100 dark:bg-orange-900/30',
            'Scheduled': 'text-blue-600 dark:text-blue-400 bg-blue-100 dark:bg-blue-900/30'
        };
        return classes[status] || classes['Pending Approval'];
    };

    return (
        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-gray-200 dark:border-gray-700">
            <div className="p-6 border-b border-gray-200 dark:border-gray-700">
                <h2 className="text-lg font-semibold text-gray-900 dark:text-white">
                    Upcoming Changes
                </h2>
            </div>

            <div className="p-6">
                <div className="space-y-4">
                    {changes.map((change, index) => (
                        <motion.div
                            key={change.id}
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ delay: index * 0.1 }}
                            className="p-4 bg-gray-50 dark:bg-gray-700/50 rounded-lg"
                        >
                            <div className="flex items-start justify-between mb-3">
                                <div>
                                    <h3 className="font-medium text-blue-600 dark:text-blue-400">
                                        {change.id}
                                    </h3>
                                    <p className="text-sm font-medium text-gray-900 dark:text-white mt-1">
                                        {change.title}
                                    </p>
                                </div>
                                <span className={`px-2 py-1 text-xs font-medium rounded-full ${getRiskClass(change.risk)}`}>
                                    {change.risk} Risk
                                </span>
                            </div>

                            <div className="flex items-center justify-between">
                                <span className={`px-2 py-1 text-xs font-medium rounded-full ${getStatusClass(change.status)}`}>
                                    {change.status}
                                </span>
                                <div className="flex items-center space-x-1 text-sm text-gray-600 dark:text-gray-400">
                                    <SafeIcon icon={FiClock} className="w-4 h-4" />
                                    <span>{change.scheduledDate}</span>
                                </div>
                            </div>
                        </motion.div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default UpcomingChanges;